module.exports = __webpack_public_path__ + "static/car-pc/img/array-down.abbd8fb2.svg";